import { render, staticRenderFns } from "./vuex-date-pair.vue?vue&type=template&id=3213367b&scoped=true"
import script from "./vuex-date-pair.vue?vue&type=script&lang=js"
export * from "./vuex-date-pair.vue?vue&type=script&lang=js"
import style0 from "./vuex-date-pair.vue?vue&type=style&index=0&id=3213367b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213367b",
  null
  
)

export default component.exports